import React, { useState, Fragment } from "react";
import { withLastLocation } from "react-router-last-location";
import { FormContainer } from "./components/FormContainer";
import { Upload } from "../../components/Dasboard_Components/Upload";
import { ButtonContainer, Button } from "./dashboardLayoutStyle";
import GetAppIcon from "@material-ui/icons/GetApp";
import styled, { css } from "styled-components";
import CheckIcon from "@material-ui/icons/Check";
import CachedIcon from "@material-ui/icons/Cached";

import { defaultFont } from "../../theme/typography";
import {
  green400,
  green100,
  white,
  curiousBlue300,
  cinnabar100,
  cinnabar400,
  blue300
} from "../../theme/colors";
import { FormRow } from "./components/FormRow";
import FileUpload from "../../components/FileUpload";
import AlertBox from "../../components/ui/AlertBox";
import { DASHBOARDROUTES } from "../../helpers/constants/routes";
import { AppConfig } from "../../app-config";

export const Anchor = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: ${(props) => props.background || curiousBlue300};
  color: ${(props) => props.color || "#FFFFFF"};
  font-size: ${(props) => props.fontSize || "13px"};
  font-weight: 500;
  padding: ${(props) => props.padding || "6px 14px"};
  height: 34px;
  box-sizing: border-box;
  margin-left: ${({ align }) => align === "right" && `12px`};
  margin-right: ${({ align }) => align === "left" && `12px`};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  white-space: nowrap;
  width: auto;
  max-width: fit-content;

  svg {
    font-size: 16px !important;
    vertical-align: middle;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(91, 127, 220, 0.15);
    filter: brightness(1.08);
    color: ${(props) => props.color || "#FFFFFF"};
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
    height: 32px;
    width: auto !important;
    max-width: fit-content !important;

    svg {
      font-size: 15px !important;
    }
  }
`;

const ButtonWrapper = styled(Button)`
  position: relative;

  input[type="file"] {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
  ${props => props.isDisabled && css`
        pointer-events:none;
        opacity: 0.8;
  `}
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
 >a {
    color: ${blue300};
    text-decoration: underline;
  }
`;

const SideElement = ({ path, history, children, type }) => {
  const isEditPayout = type === "workflow_edit_payout_plotting";

  let sampleFileUrl = path;


  if (type === "workflow_edit_payout_plotting") {
    sampleFileUrl =
      `https://gprs-migration.s3.ap-south-1.amazonaws.com/files/EditPayoutPlottingBulkUploadExample/example.xlsx`;
  } else if (type === "auto_draft_invoice_upload") {
    sampleFileUrl =
      `https://gprs-migration.s3.ap-south-1.amazonaws.com/files/AutoDraftInvoiceBulkUploadExample/example.xlsx`;
  }
  return (
    <ButtonContainer>
      {children}

      {path === `${AppConfig.api_url}/bulk/upload/help/?object=ifsc_codes&sub_project=id` ||
        path === `${AppConfig.api_url}bulk/upload/help/?object=ifsc_codes&sub_project=id` ? (
        <button
          style={{
            backgroundColor: curiousBlue300,
            color: "#fff",
            padding: "10px 18px",
            border: "1px solid transparent",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 500,
            boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
            transition: "all 0.2s ease",
          }}
          onClick={() => {
            history.push(DASHBOARDROUTES.IFSC_CHANGE_VERIFICATION);
          }}
        >
          Custom IFSC Update
        </button>
      ) : path === `${AppConfig.api_url}/bulk/upload/help/?object=unicorn_interface&sub_project=id` ||
        path === `${AppConfig.api_url}bulk/upload/help/?object=unicorn_interface&sub_project=id` ? (
        <>
          <button
            style={{
              backgroundColor: curiousBlue300,
              color: "#fff",
              padding: "10px 18px",
              border: "1px solid transparent",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
              transition: "all 0.2s ease",
            }}
            onClick={() => {
              history.push(DASHBOARDROUTES.MAP_UNICORN_MATCHING_INTERFACE);
            }}
          >
            Unicorn Mapping RSID
          </button>

          <button
            style={{
              backgroundColor: curiousBlue300,
              color: "#fff",
              padding: "10px 18px",
              border: "1px solid transparent",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
              transition: "all 0.2s ease",
            }}
            onClick={() => {
              window.open(DASHBOARDROUTES.MY_DOWNLOADS);
            }}
          >
            My Downloads
          </button>
        </>
      ) : null}

      <Anchor
        href={sampleFileUrl}
        target="_blank"
      >
        <GetAppIcon />
        Download Sample File
      </Anchor>
    </ButtonContainer>


  );
};

const BulkUpload = ({
  callback,
  uploadAction,
  downloadParam,
  downloadPath,
  activateAction,
  objectType = "Ready Reckoner Upload",
  backToList = () => { },
  backToListText = "",
  history,
  headerText = "Upload",
  processAction = () => { },
  enableSuccessAlert = true,
  uploadSuccessText = null,
  fileAllowedText = '',
  customElement,
  activationExtraKey,
  showFileInput,
  disableSuccess = false,
  setUpload
}) => {
  const [showSuccess, setSuccess] = useState(false);
  const [showActivated, setActivated] = useState(false);
  const [showFailed, setFailed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showLoading, setLoading] = useState(false);
  const [file, setFile] = useState("");
  const [mergeClicked, setMergeClicked] = useState(false)
  const [fileUploadedId, setFileUploaded] = useState(null);

  const showError = () => {
    if (errorMessage.detail && errorMessage.detail.length) {
      return <p>{errorMessage.detail}</p>
    } else if (errorMessage.file && errorMessage.file.length) {
      return <p>{errorMessage.file}</p>
    } else {
      const errorKeys = Object.keys(errorMessage);
      const filteredErrors = errorKeys.filter((e) => e > 0);

      return filteredErrors.map((item, inx) => {
        const tgtObj = errorMessage[item];
        const keys = Object.keys(tgtObj);

        return (
          <div>
            <b>Found errors in the Row No: {item}</b>
            <ul>
              {keys.map((i) => {
                if (Array.isArray(tgtObj[i]) || typeof tgtObj[i] === "string") {
                  return <li>{i ? i.replace('_', ' ') : ''} - {tgtObj[i]}</li>;
                } else {
                  return (
                    <li>
                      {i ? i.replace('_', ' ') : ''}
                      <ul>
                        {Object.keys(tgtObj[i] || {}).map((data) => {
                          return <li>{data} - {tgtObj[i][data]}</li>;
                        })}
                      </ul>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        );
      });
    }
  };

  const uploadFile = (data) => {
    setLoading(true);
    const subProjId = (history.location.state || {}).subProjectId || (history.location.state || {}).subProject || "";
    const hasSubProjectInParam = downloadParam && downloadParam.includes("sub_project=");
    const sub_project = (!hasSubProjectInParam && subProjId) ? `&sub_project=${subProjId}` : "";
    const downloadParams = downloadParam ? (hasSubProjectInParam ? downloadParam : downloadParam + sub_project) : sub_project;


    uploadAction(data, objectType, downloadParams)
      .then((res) => {
        setLoading(false);
        setSuccess(true);
        setFailed(false);
        setFileUploaded(res.id);
        processAction(true, res.id);
        setUpload && setUpload(res.id)
      })
      .catch((e) => {
        setLoading(false);
        setSuccess(false);
        setFailed(true);
        setErrorMessage(e);
        processAction(false, e);
      });
  };

  const fileUpload = (files) => {
    let file = files[0];
    if (file) {
      let imageData = new FormData();
      imageData.append("file", file);

      uploadFile(imageData);
    }
  };
  const params = (history.location && (history.location.state || {}).subProjectId) ? `&sub_project=${(history.location.state || {}).subProjectId}` : ""

  return (
    <Fragment>
      {showFileInput ?
        <FormContainer
          padding="0px"
          title={"Bulk WhatsApp Message"}
          className="text"
          footerLocation={"50%"}
          onClickAction={() => {
            uploadFile(file.fileData)
          }}
          isLoading={showLoading}
          onCancelAction={() => { setFile({}) }}
          isClickDisabled={showLoading}
          actionButtonText={"Upload"}
        >
          <Row style={{ marginBottom: "16px", alignItems: "center" }}>
            <span style={{ fontSize: "14px", fontWeight: "600", color: "#334155" }}>Upload Data for Bulk WhatsApp Message</span>
            <a
              href={downloadPath}
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "6px 12px",
                background: "#eff6ff",
                color: "#2563eb",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "600",
                textDecoration: "none",
                border: "1px solid #bfdbfe",
                transition: "all 0.2s ease"
              }}
            >
              <GetAppIcon style={{ fontSize: "16px" }} />
              Download Template
            </a>
          </Row>
          <FormRow
            leftSideWidth={"0"}
            margin="0"
            rightElement={
              <FileUpload
                boxWidth={"100%"}
                type="file"
                inputLabel="No File Choosen"
                customValue={file.fileName || " "}
                customFunction={(formData, fileName) => { setFile({ fileData: formData, fileName }) }}
              >
                Choose File
              </FileUpload>
            }
          />
        </FormContainer>
        :
        <FormContainer
          margin="0"
          title={headerText}
          className="text"
          footerLocation={"57%"}
          actionButtons={false}
          rightSideTitleElement={
            <Fragment>
              <SideElement path={downloadPath + params} history={history} type={objectType}>
                {customElement && customElement()}
              </SideElement>
            </Fragment>

          }
        >
          <Upload onGetImageData={uploadFile} isLoading={showLoading} fileAllowedText={fileAllowedText} />
        </FormContainer>
      }
      {showSuccess || showFailed ? (
        <AlertBox isFailed={showFailed} boxWidth={showFileInput ? "auto" : ""}>
          {showSuccess ? (
            <p>
              {uploadSuccessText
                ? uploadSuccessText
                : showActivated
                  ? "Completed Upload Successfully"
                  : "Completed Processing Successfully"}
            </p>
          ) : (
            showError()
          )}
          <ButtonContainer style={mergeClicked ? { cursor: 'not-allowed' } : {}}>
            {showFailed ? (
              <ButtonWrapper as="button" background={cinnabar400} color={white}>
                <CachedIcon style={{ color: white }} />
                Reupload
                <input
                  type="file"
                  // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={(e) => {
                    //  e && e.preventDefault();

                    fileUpload(e.target.files);
                  }}
                  onClick={(event) => {
                    event.currentTarget.value = null
                  }}
                />
              </ButtonWrapper>
            ) :
              null}
          </ButtonContainer>
        </AlertBox>
      ) : null}
    </Fragment>
  );
};

export default withLastLocation(BulkUpload);

